import React, { useEffect, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { connect, ConnectedProps } from 'react-redux';
import { Api } from '../../logic/Api/Api';
import { RootState } from '../../logic/store/Store';
import { JSONTreeWithCopy as JSONTree } from '../../components/JSONTreeWithCopy/JSONTreeWithCopy';

/**
 * Present tools to retrieve the grower's JdConnect info
 */
const GrowerJdConnectInfo = (props: PropsFromRedux) => 
{
	const [enteredSearchTerm, setEnteredSearchTerm] = useState<string>('');
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [jdConnectInfo, setjdConnectInfo] = useState<object>();

	// When a new search term is committed, fetch the JdConnect info from the server
	useEffect(()=>
	{
		if(!searchTerm)
		{
			return;
		}

		const execute = async () => 
		{
			const api = new Api('/api/4', props.userAuthToken, undefined);
			try
			{	
				const response = await api.getAsync<object>(`/supporttools/jd-connect/${encodeURIComponent(searchTerm)}`);	
				setjdConnectInfo(response);
			}
			catch(err)
			{
				setjdConnectInfo(err);
			}
			setIsLoading(false);
		};
		setIsLoading(true);
		execute();
	},
	[searchTerm, props.userAuthToken]);

	return (
		<Form style={{display:'flex', flexDirection:'column', alignItems:'stretch', height: '100%', position: 'relative'}}>
			<h1>Grower JdConnectInfo</h1>
			<div style={{display: 'flex', flexDirection: 'row', alignItems: 'stretch'}}>
				<Form.Item label="Search term" style={{width: 400, marginRight: 12}}>
					<Input disabled={isLoading} value={enteredSearchTerm} onChange={(e) => setEnteredSearchTerm(e.currentTarget.value)} placeholder='Grower Id' />
				</Form.Item>
				<Button onClick={() => setSearchTerm(enteredSearchTerm)}>Search</Button>
			</div>
			<div style={{flexGrow: 1, overflow: 'auto', border: '1px solid #ccc', borderRadius: 4, padding: 8, backgroundColor: '#f6f8fa'}}>
				<JSONTree
					data={jdConnectInfo}
					theme={'summerfruit'}
					invertTheme={false}
					shouldExpandNodeInitially={() => true}
				/>
			</div>
		</Form>
	);
};

const mapStateToProps = (state: RootState) => ({
	userAuthToken: state.auth.userAuthToken,
	UserId: state.userInfo.UserId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export const GrowerJdConnectInfoTroubleShootingToolComponent = connector(GrowerJdConnectInfo);
